import http from 'Support/services/HttpService';

class ManageOfferRequest {
  static baseUrl() {
    return '/v1/ofertas';
  }

  static save(payload) {
    if (payload.action) {
      return this.createOffer(payload.data);
    }
    return this.deleteOffer(payload.data);
  }

  static createOffer(payload) {
    return http.post(this.baseUrl(), payload);
  }

  static deleteOffer(payload) {
    return http.delete(`${this.baseUrl()}/deletar`, { data: payload });
  }
}

export default ManageOfferRequest;
